"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var protocol_base_1 = require("./utilities/protocol-base");
/**
 * An attachment contained within a StreamingRequest's stream collection,
 * which itself contains any form of media item.
 */
var HttpContentStream = /** @class */ (function () {
    /**
     * Initializes a new instance of the [HttpContentStream](xref:botframework-streaming.HttpContentStream) class.
     * @param content The [HttpContent](xref:botframework-streaming.HttpContent) to assign to the [HttpContentStream](xref:botframework-streaming.HttpContentStream).
     */
    function HttpContentStream(content) {
        this.id = protocol_base_1.generateGuid();
        this.content = content;
        this.description = {
            id: this.id,
            type: this.content.headers ? this.content.headers.type : 'unknown',
            length: this.content.headers ? this.content.headers.contentLength : 0,
        };
    }
    return HttpContentStream;
}());
exports.HttpContentStream = HttpContentStream;
/**
 * The HttpContent class that contains a [SubscribableStream](xref:botframework-streaming.SubscribableStream).
 */
var HttpContent = /** @class */ (function () {
    /**
     * Initializes a new instance of the [HttpContent](xref:botframework-streaming.HttpContent) class.
     * @param headers The Streaming Http content header definition.
     * @param stream The stream of buffered data.
     */
    function HttpContent(headers, stream) {
        this.headers = headers;
        this.stream = stream;
    }
    /**
     * Gets the data contained within this [HttpContent](xref:botframework-streaming.HttpContent).
     */
    HttpContent.prototype.getStream = function () {
        return this.stream;
    };
    return HttpContent;
}());
exports.HttpContent = HttpContent;
//# sourceMappingURL=httpContentStream.js.map